<template>
  <div class="name-cell">
    <!-- Icon or image based on central configuration -->
    <v-icon
      v-if="iconConfig.type === 'icon'"
      small
      :class="iconConfig.class"
      :title="$t(iconConfig.title)"
    >
      {{ iconConfig.icon }}
    </v-icon>

    <v-img
      v-else-if="iconConfig.type === 'image'"
      class="mr-2"
      :src="iconConfig.imageSrc"
      :height="iconConfig.height"
      :width="iconConfig.width"
      :title="$t(iconConfig.title)"
      contain
    />

    <span class="name-text">{{ row.name }}</span>
  </div>
</template>

<script>
import { TagIconConfig } from '@/utils/tagIconConfig';

export default {
  name: 'TagNameCellComponent',
  props: {
    params: { type: Object, required: false, default: null },
    tag: { type: Object, required: false, default: null },
  },
  computed: {
    row() {
      // Support both 'params' (DataTable) and 'tag' (MapView)
      return this.tag || this.params || {};
    },
    iconConfig() {
      return TagIconConfig.getConfig(this.row);
    },
  },
};
</script>

<style scoped>
.name-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
}
.name-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
